export * from './replace.directive';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/directives/replace/index.ts